import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL, UseGraphqlOptions } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query reportBuilderReportById($id: MongoID!) {
    cat {
      reporting {
        builder {
          report {
            byId(_id: $id) {
              _id
              title
              model
              query
              fields
              createdAt
              updatedAt
              _createdBy {
                _id
                name
              }
              _updatedBy {
                _id
                name
              }
            }
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type ReportBuilderReportById = NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['reporting']>['builder']>['report']>['byId']>

const useReportBuilderReportById = (id: string, options?: UseGraphqlOptions<TData>): ReportBuilderReportById | undefined => {
  const { data } = useGraphQL(document, { id }, options)
  return data?.cat?.reporting?.builder?.report?.byId ?? undefined
}

export { useReportBuilderReportById, document as reportBuilderReportByIdDocument }
